<div class="grid expired-token-container full-height-grid">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content mt-6 pl-6">
    <h2 class="link-Expired">{{ 'ExpiredToken.EmailStatus' | translate }}</h2>
    <br />
    <span class="large-paragraph link-message">
      {{ 'ExpiredToken.LinkExpiredMessage' | translate }}
      <br />
    </span>
    @if (resendLinkStatus$ | async; as state) {
      <p-button [label]="'ExpiredToken.RequestNewLink' | translate"
        styleClass="p-button-rounded"
        class="p-2"
        [disabled]="state === actionStatus.Success"
        [loading]="state === actionStatus.Pending"
        (click)="onRequestLink()" />
    }
    <div class="col-12">
      <div class="col-3 col-offset-5">
        <app-language-selector />
      </div>
    </div>
  </div>
</div>
